import clsx from 'clsx'

interface Props {
  title: string
  statistics: {
    stat: string
    color: string | null
    description?: string
  }[]
  bgColor?: string
  isDark?: boolean
}

function Statistics({ title, statistics, ...props }: Props): JSX.Element {
  return (
    <section
      className={clsx(
        'font-heading',
        props.isDark ? 'bg-blue-web-90 text-white' : 'text-blue-web-90'
      )}
      style={{ background: props.isDark ? 'bg-blue-web-90' : props.bgColor }}
    >
      <div className="container | py-10 md:py-18">
        {title ? (
          <h2
            className="text-3xl lg:text-5xl font-semibold | mb-12"
            dangerouslySetInnerHTML={{ __html: title }}
          ></h2>
        ) : null}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-28 justify-center items-center">
          {statistics?.map((statistic, index) => (
            <div
              key={`statistic_${index}`}
              className={clsx(
                index === statistics.length - 1
                  ? ''
                  : 'border-b md:border-r md:border-b-0',
                props.isDark ? 'border-yellow-40' : 'border-blue-web-50'
              )}
            >
              <h3
                className="text-5xl lg:text-6xl font-semibold"
                dangerouslySetInnerHTML={{ __html: statistic.stat }}
              />

              <span
                className="text-base font-semibold inline-block | w-48 mb-8 md:mb-0"
                dangerouslySetInnerHTML={{
                  __html: statistic.description ?? ''
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Statistics
